import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const paySettingRoute = {
    SAVE: "dashboard/pay/setting/save",
    LIST_METHOD_SETTING : "dashboard/pay/setting/list-method-setting",

};
export default {
    save(paySetting) {
        let code = -1;
        return new Promise(resolve => {
            http.post(paySettingRoute.SAVE, paySetting)
                .then(({data}) => {
                    code = data.code;
                    if (code > 0) {
                        toast.ok("Se registró la configuración del pago correctamente");
                        return;
                    }
                    toast.error(data.message);
                })
                .catch(() => toast.error("Error al guardar la configuración"))
                .finally(() => resolve(code));
        });
    },
    getlistMethodSettingByCompany: function () {
        return new Promise(resolve => {
            let newData = [];
            http.get(paySettingRoute.LIST_METHOD_SETTING)
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron métodos de esta compañia");
                        return;
                    }
                    if (code < 0) {
                        toast.error("Error al consultar los métodos");
                        return;
                    }
                    newData = data.info;
                }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
};